import type { StripeConnectInstance } from "@stripe/connect-js";

import { addDatadogError } from "@/core/monitoring";

const instances = new Set<StripeConnectInstance>();
let loginGeneration = 0;

export function getStripeConnectLoginGeneration() {
  return loginGeneration;
}

export function assertStripeConnectLogin(expectedLoginGeneration: number) {
  if (expectedLoginGeneration !== loginGeneration) {
    throw new Error("Stripe account session belongs to an ended login.");
  }
}

export function registerStripeConnectSession(instance: StripeConnectInstance) {
  // Keep instances after navigation so application logout can still invalidate them.
  instances.add(instance);
}

export function logoutStripeConnectSessions() {
  loginGeneration += 1;
  const endedInstances = [...instances];
  instances.clear();
  for (const instance of endedInstances) {
    void instance.logout().catch(() => {
      // Never report Stripe's error payload, which can contain account/session details.
      addDatadogError(new Error("Stripe embedded session logout failed."));
    });
  }
}
